var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useApi from '@/hoc/hooks/useApi';
import { UpArrow } from '@/icons';
import { RightArrow } from '@/icons/right-arrow';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Modal from '../generic-customization-modal';
var StagesListSection = function (_a) {
    var isOpen = _a.isOpen, mode = _a.mode, selectedItem = _a.selectedItem, onClose = _a.onClose, onSave = _a.onSave, stagesItem = _a.stagesItem;
    var _b = useForm({
        defaultValues: {
            name: '',
            description: '',
            selectedStages: [],
        },
        mode: 'onChange', // Validate on every change
    }), register = _b.register, handleSubmit = _b.handleSubmit, setValue = _b.setValue, reset = _b.reset, errors = _b.formState.errors, setError = _b.setError, clearErrors = _b.clearErrors, getValues = _b.getValues, watch = _b.watch;
    var _c = useState([]), stagesList = _c[0], setStagesList = _c[1];
    var _d = useState({}), expandedStages = _d[0], setExpandedStages = _d[1];
    var _e = useApi('/stage'), fetchData = _e.fetchData, data = _e.data, loading = _e.loading;
    useEffect(function () {
        fetchData();
    }, [fetchData]);
    var watchSelectedStages = watch('selectedStages');
    useEffect(function () {
        var _a;
        var selectedStages = (_a = ((stagesList === null || stagesList === void 0 ? void 0 : stagesList.filter(function (stage) { return stage.isDefault; })) || [])) === null || _a === void 0 ? void 0 : _a.map(function (stage) { return stage._id; });
        setValue('selectedStages', selectedStages, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
        });
    }, [stagesList]);
    useEffect(function () {
        if (data) {
            setStagesList(data);
            // Expand all stages by default
            var defaultExpanded_1 = {};
            data.forEach(function (stage) {
                defaultExpanded_1[stage._id] = true; // Expand parent stages
            });
            setExpandedStages(defaultExpanded_1);
        }
        else {
            fetchData().catch(function (error) { return console.error('Error fetching stage data: ', error); });
        }
    }, [data]);
    useEffect(function () {
        var _a;
        if (isOpen) {
            if (mode === 'edit' && selectedItem) {
                reset({
                    name: selectedItem.name,
                    description: selectedItem.description,
                    selectedStages: selectedItem.stageId || [],
                });
            }
            else if (mode === 'create') {
                // Create mode: set default selected stages from isDefault
                var defaultSelectedStages = (_a = ((stagesList === null || stagesList === void 0 ? void 0 : stagesList.filter(function (stage) { return stage.isDefault; })) || [])) === null || _a === void 0 ? void 0 : _a.map(function (stage) { return stage._id; });
                reset({
                    name: '',
                    description: '',
                    selectedStages: defaultSelectedStages,
                });
            }
        }
        else {
            // If modal is closed, reset form to initial state
            reset();
        }
    }, [isOpen, mode, selectedItem, stagesList, reset]);
    var toggleExpand = function (stageId) {
        setExpandedStages(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[stageId] = !prev[stageId], _a)));
        });
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, { title: mode === 'view' ? 'Stages List' : '', isOpen: isOpen, onClose: onClose, cancelButton: { label: 'Cancel', onClick: onClose }, children: _jsx("div", { className: 'w-full', children: stagesList.length === 0 ? (
                // Loader Section
                _jsx("div", { className: 'flex justify-center items-center min-h-[150px]', children: _jsx("div", { className: 'loader border-t-transparent border-solid rounded-full border-blue-500  border-4 w-8 h-8 animate-spin' }) })) : (
                // Modal Content
                _jsx("div", { className: 'max-h-50 w-full border border-vjwSecondary rounded-lg p-2 bg-blue-50', children: stagesItem.map(function (stage, parentIndex) { return (_jsxs("div", { className: 'mb-2', children: [_jsxs("div", { className: 'flex items-center', children: [_jsxs("span", { className: 'text-sm', children: [parentIndex + 1, ". ", stage.name] }), stage.children && stage.children.length > 0 && (_jsx("button", { type: 'button', onClick: function () { return toggleExpand(stage._id); }, className: 'ml-2 text-xs text-blue-500', children: expandedStages[stage._id] ? _jsx(UpArrow, {}) : _jsx(RightArrow, {}) }))] }), expandedStages[stage._id] && stage.children && (_jsx("div", { className: 'ml-5 pl-3 border-l-2 border-vjwSecondary', children: stage.children.map(function (subStage, subIndex) { return (_jsxs("div", { className: 'flex items-center mt-1', children: [_jsx("input", { type: 'checkbox', checked: watchSelectedStages === null || watchSelectedStages === void 0 ? void 0 : watchSelectedStages.includes(subStage._id), className: 'mr-2' }), _jsxs("span", { className: 'text-sm', children: [parentIndex + 1, ".", subIndex + 1, " ", subStage.name] })] }, subStage._id)); }) }))] }, stage._id)); }) })) }) }) }));
};
export default StagesListSection;
